// extracted by mini-css-extract-plugin
export default {"label":"style_label__T3ax8","row":"style_row__+YSOm"};